import Vue from "vue";
import store from "@/store";

const storeOnline = {
  install(Vue) {
    Vue.prototype.$appStoreOnline = {
      check: function () {
        if (store.getters.storeInfo) {
          store.dispatch("storeInfo/setStoreOnline", {
            status: store.getters.storeInfo.statusOnline,
            message: store.getters.storeInfo.statusOnline
              ? ""
              : "discovery.store_offline",
          });

          if (!store.getters.storeInfo.publishableKey) {
            store.dispatch("storeInfo/setStoreOnline", {
              status: false,
              message: "discovery.store_not_configured",
            });
          }
        }
      },
    };
  },
};
Vue.use(storeOnline);
